<template>
  <div class="app-container">
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.operate')"
        min-width="200"
        prop="operateType"
      />
      <el-table-column
        :label="$t('trajectory.Time')"
        min-width="180"
        prop="operateTime"
      />
      <el-table-column
        :label="$t('collectionCenter.detail')"
        min-width="500"
        prop="operateDescription"
      />
      <el-table-column
        :label="$t('GlobalSetObj.operator')"
        min-width="180"
        prop="operateUserName"
      />
      <el-table-column
        :label="$t('GlobalSetObj.OperationSite')"
        min-width="200"
        prop="operateUserSiteName"
      />
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0;float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { waybillOperationLogpage } from '@/api/logisticsOrders/index.js';
import dayjs from 'dayjs';

export default {
  name: 'OperationalLogs',
  props: {
    queryTrackParam: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      // 是否格式化成巴西时间
      isTormat: false,
      queryForm: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        needToSort: true,
        orderProperty: 'operate_time',
        orderDirection: 'desc',
        params: {
          waybillNumber: ''
        }
      },
      tableData: []
    };
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getSearch();
  },
  methods: {
    // 查询
    getSearch() {
      this.queryForm.params.waybillNumber = this.queryTrackParam.waybillNumber;
      console.log(this.queryForm, 'this.queryFormthis.queryFormthis.queryForm');
      waybillOperationLogpage(this.queryForm).then(res => {
        if (res.status === 'OK') {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          // this.tableData.map(item => {});
        }
      });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 获取最近一星期时间
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      console.log(brazilTime);
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      return {
        today
      };
    }
  }
};
</script>

<style scoped>
>>> .el-table__row {
  font-weight: bold;
}
</style>

